var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowKeyboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.20875 5.50023H8.79375L7.35375 4.06023C7.15875 3.86523 7.15875 3.55023 7.35375 3.35523C7.54875 3.16023 7.86375 3.16023 8.05875 3.35523L10.3538 5.65023C10.5487 5.84523 10.5487 6.16023 10.3538 6.35523L8.05875 8.65023C7.86375 8.84523 7.54875 8.84523 7.35375 8.65023C7.15875 8.45523 7.15875 8.14023 7.35375 7.94523L8.79375 6.50023H2.20875C1.93375 6.50023 1.70875 6.27523 1.70875 6.00023C1.70875 5.72523 1.93375 5.50023 2.20875 5.50023Z",
    fill: "white",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowKeyboard);
export default __webpack_public_path__ + "static/media/arrow-keyboard.67d201935201f9a580328ac2faf1a20e.svg";
export { ForwardRef as ReactComponent };